import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logoBlack from "../../images/logos/logo-sub-white.png";
import logoWhite from "../../images/logos/logo-sub-black.png";
import MobileMenu from "../MobileMenu/MobileMenu";
import WeatherUb from "../weather/weather";
import Facebook from "../Socials/Facebook";

const Header = ({ hclass, isDark }) => {
  const [searchActive, setSearchState] = useState(false);
  const [mobailActive, setMobailState] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const SubmitHandler = (e) => {
    e.preventDefault();
  };
  const logo = isDark ? logoBlack : logoWhite;
  const [isSticky, setSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <header
        className={`header header--styleOne sticky-on  ${
          isSticky ? "sticky" : ""
        }  ${hclass}`}
      >
        <div id="sticky-placeholder"></div>
        <div className="container container--custom">
          <div className="row">
            <div className="col-12">
              <div className="header__wrapper">
                <div className="header__logo">
                  <Link
                    onClick={ClickHandler}
                    to="/"
                    className="header__logo__link"
                  >
                    <img
                      src={logo}
                      alt="Mcclogo"
                      className="header__logo__image"
                    />
                  </Link>
                </div>
                <div className="header__menu">
                  <nav className="mainMenu">
                    <ul>
                      <li>
                        <Link onClick={ClickHandler} to="/taniltsuulga">
                          Танилцуулга
                        </Link>
                      </li>
                      <li className="dropdown">
                        <Link to="">Үндсэн үйл ажиллагаа</Link>
                        <ul className="dropdown_menu dropdown_menu-2">
                          <li className="dropdown_item-1">
                            <Link onClick={ClickHandler} to="/dotood-ua">
                              Дотоод үйл ажиллагаа
                            </Link>
                          </li>
                          <li className="dropdown_item-2">
                            <Link onClick={ClickHandler} to="/tsuglaan">
                              Бүх гишүүдийн цуглаан
                            </Link>
                          </li>
                          <li className="dropdown_item-3">
                            <Link onClick={ClickHandler} to="/urlag-sport">
                              Урлаг спорт
                            </Link>
                          </li>
                          <li className="dropdown_item-4">
                            <Link onClick={ClickHandler} to="/sain-dur">
                              Сайн дурын үйл ажиллагаа
                            </Link>
                          </li>
                          <li className="dropdown_item-5">
                            <Link onClick={ClickHandler} to="/bidnii-amjilt">
                              Бидний амжилт
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link onClick={ClickHandler} to="/medee-medeelel">
                          Мэдээ мэдээлэл
                        </Link>
                      </li>
                      <li>
                        <Link onClick={ClickHandler} to="/bidentei-holbogdoh">
                          Холбоо барих
                        </Link>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          className=""
                          href="https://mccpray.netlify.app/"
                          rel="noreferrer"
                        >
                          <span className="btn__text">Залбирал</span>
                        </a>
                      </li>
                      {/* <li className="dropdown">
                        <Link onClick={ClickHandler} to="/home">
                          Pages
                        </Link>
                        <ul className="dropdown_menu dropdown_menu-2">
                          <li className="dropdown_item-1">
                            <Link onClick={ClickHandler} to="/events">
                              Events
                            </Link>
                          </li>
                          <li className="dropdown_item-1">
                            <Link
                              onClick={ClickHandler}
                              to="/event-single/The-Human-rights-and-democracy-programme"
                            >
                              Event Single
                            </Link>
                          </li>
                          <li className="dropdown_item-1">
                            <Link onClick={ClickHandler} to="/service">
                              Service
                            </Link>
                          </li>
                          <li className="dropdown_item-1">
                            <Link
                              onClick={ClickHandler}
                              to="/service-single/Study-&-Life-Tips"
                            >
                              Service Single
                            </Link>
                          </li>
                          <li className="dropdown_item-5">
                            <Link onClick={ClickHandler} to="/volunteers">
                              Volunteers
                            </Link>
                          </li>
                          <li className="dropdown_item-5">
                            <Link
                              onClick={ClickHandler}
                              to="/team-single/Cameron-Williamson"
                            >
                              Volunteer Single
                            </Link>
                          </li>
                          <li className="dropdown_item-5">
                            <Link onClick={ClickHandler} to="/contact">
                              Contacts
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <Link onClick={ClickHandler} to="/products">
                          Shop
                        </Link>
                        <ul className="dropdown_menu dropdown_menu-2">
                          <li className="dropdown_item-3">
                            <Link onClick={ClickHandler} to="/products">
                              Shop
                            </Link>
                          </li>
                          <li className="dropdown_item-3">
                            <Link
                              onClick={ClickHandler}
                              to="/product-single/Yellow-Rocks-Umbrealla"
                            >
                              Shop Single
                            </Link>
                          </li>
                          <li className="dropdown_item-4">
                            <Link onClick={ClickHandler} to="/cart">
                              Carts
                            </Link>
                          </li>
                          <li className="dropdown_item-4">
                            <Link onClick={ClickHandler} to="/checkout">
                              Checkout
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <Link onClick={ClickHandler} to="/blog">
                          Blog
                        </Link>
                        <ul className="dropdown_menu dropdown_menu-2">
                          <li className="dropdown_item-1">
                            <Link onClick={ClickHandler} to="/blog">
                              Blog Page
                            </Link>
                          </li>
                          <li className="dropdown_item-2">
                            <Link
                              onClick={ClickHandler}
                              to="/blog-details/Start-a-fundraiser-for-yourself-in-World-Charity-Day"
                            >
                              Blog Details
                            </Link>
                          </li>
                        </ul>
                      </li> */}
                    </ul>
                  </nav>
                </div>
                <div className="header__right">
                  <WeatherUb />
                  <div className="header__button">
                    <a
                      target="_blank"
                      className="btn btn--styleOne btn--primary it-btn"
                      href="https://www.youtube.com/@biblenom"
                      rel="noreferrer"
                    >
                      <span className="btn__text">Библи</span>
                      <i className="fa-solid fa-heart btn__icon"></i>
                      <span className="it-btn__inner">
                        <span className="it-btn__blobs">
                          <span className="it-btn__blob"></span>
                          <span className="it-btn__blob"></span>
                          <span className="it-btn__blob"></span>
                          <span className="it-btn__blob"></span>
                        </span>
                      </span>
                      <svg
                        className="it-btn__animation"
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                      >
                        <defs>
                          <filter>
                            <feGaussianBlur
                              in="SourceGraphic"
                              result="blur"
                              stdDeviation="10"
                            ></feGaussianBlur>
                            <feColorMatrix
                              in="blur"
                              mode="matrix"
                              values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                              result="goo"
                            ></feColorMatrix>
                            <feBlend
                              in2="goo"
                              in="SourceGraphic"
                              result="mix"
                            ></feBlend>
                          </filter>
                        </defs>
                      </svg>
                    </a>
                  </div>
                  <div className="header__button">
                    <a
                      target="_blank"
                      className="btn btn--styleOne btn--primary it-btn"
                      href="https://www.facebook.com/share/14dRwFd8qmJ/"
                      rel="noreferrer"
                    >
                      <span className="btn__text">YES</span>
                      <i className="fa-solid fa-bullhorn btn__icon"></i>
                      <span className="it-btn__inner">
                        <span className="it-btn__blobs">
                          <span className="it-btn__blob"></span>
                          <span className="it-btn__blob"></span>
                          <span className="it-btn__blob"></span>
                          <span className="it-btn__blob"></span>
                        </span>
                      </span>
                      <svg
                        className="it-btn__animation"
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                      >
                        <defs>
                          <filter>
                            <feGaussianBlur
                              in="SourceGraphic"
                              result="blur"
                              stdDeviation="10"
                            ></feGaussianBlur>
                            <feColorMatrix
                              in="blur"
                              mode="matrix"
                              values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                              result="goo"
                            ></feColorMatrix>
                            <feBlend
                              in2="goo"
                              in="SourceGraphic"
                              result="mix"
                            ></feBlend>
                          </filter>
                        </defs>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* header--mobile */}
      <div
        className="header header--mobile cc-header-menu mean-container position-relative"
        id="meanmenu"
      >
        <div className="mean-bar headerBurgerMenu">
          <Link onClick={ClickHandler} to="/">
            <img className="mean-bar__logo" alt="mcc" src={logo} />
          </Link>

          <div className="header__right">
            <div className="header__actions">
              <ul>
                <li>
                  <button
                    className={`headerBurgerMenu__button sidebarBtn ${
                      mobailActive ? "opened" : ""
                    }`}
                    aria-label="Main Menu"
                    onClick={() => setMobailState(!mobailActive)}
                  >
                    <svg width="50" height="50" viewBox="0 0 100 100">
                      <path
                        className="line line1"
                        d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
                      />
                      <path className="line line2" d="M 20,50 H 80" />
                      <path
                        className="line line3"
                        d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
                      />
                    </svg>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* mobail-left */}
      <div className={`cc cc--slideNav ${mobailActive ? "show" : ""}`}>
        <div className="cc__logo mb-40">
          <Link onClick={ClickHandler} to="/">
            <img className="mean-bar__logo" alt="Techkit" src={logo} />
          </Link>
        </div>
        <div className="offscreen-navigation mb-40">
          <nav className="menu-main-primary-container">
            <MobileMenu />
          </nav>
        </div>
        <div className="itSocial itSocial--sidebar mb-40">
          <ul>
            <li>
              {/* <Link
                onClick={ClickHandler}
                className="facebook"
                to="/"
                rel="nofollow"
              >
                <i className="fab fa-facebook-f"></i>
              </Link> */}
              <Facebook ClickHandler={ClickHandler} />
            </li>

            {/* <li>
              <Link
                onClick={ClickHandler}
                className="instagram"
                to=""
                rel="nofollow"
              >
                <i className="fab fa-instagram"></i>
              </Link>
            </li>
            <li>
              <Link
                onClick={ClickHandler}
                className="linkedin"
                to=""
                rel="nofollow"
              >
                <i className="fab fa-telegram"></i>
              </Link>
            </li> */}
            <li>
              <a
                onClick={ClickHandler}
                className="pinterest"
                href="https://www.youtube.com/@biblenom"
                target="_blank"
                rel="nofollow noreferrer"
              >
                <i className="fab fa-youtube"></i>
              </a>
            </li>
          </ul>
        </div>
        <div className="cc__button">
          <div className="header__button">
            <a
              target="_blank"
              onClick={ClickHandler}
              className="btn btn--styleOne btn--primary it-btn"
              href="https://mccpray.netlify.app/"
              rel="noreferrer"
            >
              <span className="btn__text">Залбирал</span>
              <i className="fas fa-pray"></i>
              <span className="it-btn__inner">
                <span className="it-btn__blobs">
                  <span className="it-btn__blob"></span>
                  <span className="it-btn__blob"></span>
                  <span className="it-btn__blob"></span>
                  <span className="it-btn__blob"></span>
                </span>
              </span>
              <svg
                className="it-btn__animation"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
              >
                <defs>
                  <filter id="goo">
                    <feGaussianBlur
                      in="SourceGraphic"
                      result="blur"
                      stdDeviation="10"
                    ></feGaussianBlur>
                    <feColorMatrix
                      in="blur"
                      mode="matrix"
                      values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                      result="goo"
                    ></feColorMatrix>
                    <feBlend
                      in2="goo"
                      in="SourceGraphic"
                      result="mix"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>
            </a>
          </div>
          <div className="header__button">
            <a
              target="_blank"
              onClick={ClickHandler}
              className="btn btn--styleOne btn--primary it-btn"
              href="https://www.youtube.com/@biblenom"
              rel="noreferrer"
            >
              <span className="btn__text">Библи</span>
              <i className="fa-solid fa-heart btn__icon"></i>
              <span className="it-btn__inner">
                <span className="it-btn__blobs">
                  <span className="it-btn__blob"></span>
                  <span className="it-btn__blob"></span>
                  <span className="it-btn__blob"></span>
                  <span className="it-btn__blob"></span>
                </span>
              </span>
              <svg
                className="it-btn__animation"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
              >
                <defs>
                  <filter id="goo">
                    <feGaussianBlur
                      in="SourceGraphic"
                      result="blur"
                      stdDeviation="10"
                    ></feGaussianBlur>
                    <feColorMatrix
                      in="blur"
                      mode="matrix"
                      values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                      result="goo"
                    ></feColorMatrix>
                    <feBlend
                      in2="goo"
                      in="SourceGraphic"
                      result="mix"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>
            </a>
          </div>
          <div className="header__button">
            <a
              target="_blank"
              onClick={ClickHandler}
              className="btn btn--styleOne btn--primary it-btn"
              href="https://www.facebook.com/share/14dRwFd8qmJ/"
              rel="noreferrer"
            >
              <span className="btn__text">YES</span>
              <i className="fa-solid fa-bullhorn btn__icon"></i>
              <span className="it-btn__inner">
                <span className="it-btn__blobs">
                  <span className="it-btn__blob"></span>
                  <span className="it-btn__blob"></span>
                  <span className="it-btn__blob"></span>
                  <span className="it-btn__blob"></span>
                </span>
              </span>
              <svg
                className="it-btn__animation"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
              >
                <defs>
                  <filter id="goo">
                    <feGaussianBlur
                      in="SourceGraphic"
                      result="blur"
                      stdDeviation="10"
                    ></feGaussianBlur>
                    <feColorMatrix
                      in="blur"
                      mode="matrix"
                      values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                      result="goo"
                    ></feColorMatrix>
                    <feBlend
                      in2="goo"
                      in="SourceGraphic"
                      result="mix"
                    ></feBlend>
                  </filter>
                </defs>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* search */}
      <div
        id="template-search"
        className={`template-search ${searchActive ? "open" : ""}`}
      >
        <button
          type="button"
          className="close"
          onClick={() => setSearchState(false)}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
        <form className="search-form" onSubmit={SubmitHandler}>
          <input type="search" placeholder="Type your search" />
          <button type="submit" className="search-btn">
            <i className="fas fa-search"></i>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Header;
